import { Moment } from 'moment';
import CommonFilters from '@/shared/models/CommonFilters';

export default class SurveyFilters {
  constructor(
    readonly commonFilters: CommonFilters,
    readonly followedUpFrom: Moment,
    readonly followedUpTill: Moment,
    readonly includeFollowedUp = false,
    readonly onlyNegative = false,
  ) {}
}